module.exports = __webpack_public_path__ + "assets/b15.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b15.png
// module id = 600
// module chunks = 0